type ParagraphText =
    | string
    | {
          before: string;
          highlight: string;
          after: string;
      };

type AboutUsDescriptionProps = {
    paragraphs: ParagraphText[];
};

export default function AboutUsDescription({ paragraphs }: AboutUsDescriptionProps) {
    return (
        <div className="w-full max-w-xs md:max-w-[580px] lap:max-w-[458px] lg:max-w-[600px] xl:max-w-[580px] text-text-300 text-base">
            {paragraphs.map((text, i) => {
                const isLast = i === paragraphs.length - 1;
                const mbClass = isLast ? "" : "mb-4";

                if (typeof text === "string") {
                    return (
                        <p key={i} className={`font-normal ${mbClass}`}>
                            {text}
                        </p>
                    );
                } else {
                    return (
                        <p key={i} className={`font-normal ${mbClass}`}>
                            {text.before}
                            <span className="font-semibold">{text.highlight}</span>
                            {text.after}
                        </p>
                    );
                }
            })}
        </div>
    );
}
